import { useLocation, useNavigate, useSearchParams } from "react-router";

/** Commit a complete filter change as one history entry, retaining anchors and skipping no-ops. */
export function useViewSearch() {
  const [params] = useSearchParams();
  const location = useLocation();
  const navigate = useNavigate();
  const apply = (
    next: URLSearchParams,
    options: { readonly replace?: boolean } = {},
  ) => {
    if (next.toString() === params.toString()) return;
    void navigate(
      { search: next.toString(), hash: location.hash },
      { preventScrollReset: true, replace: options.replace ?? false },
    );
  };
  return [params, apply] as const;
}
